// @ts-nocheck
import {
    MARKET_GROUP_LIST_RECEIVED,
    MARKET_GROUP_LIST_FETCHING,
    MARKET_GROUP_ITEM_RECEIVED,
    MARKET_GROUP_ITEM_FETCHING,
    MARKET_GROUP_COLUMN_TYPES_RECEIVED,
    MARKET_GROUP_OUTCOMES_RECEIVED,
    MARKET_GROUP_MARKETS_RECEIVED,
    MARKET_GROUP_TEMPLATE_LIST_RECEIVED,
    MARKET_GROUP_TEMPLATE_LIST_FETCHING,
    MARKET_GROUP_TEMPLATE_ITEM_RECEIVED,
    MARKET_GROUP_TEMPLATE_ITEM_FETCHING,
    MARKET_GROUP_RESULT_TYPE_LIST_RECEIVED,
    MARKET_GROUP_RESULT_TYPE_LIST_FETCHING,
    MARKET_GROUP_RESULT_TYPE_ITEM_RECEIVED,
    MARKET_GROUP_RESULT_TYPE_ITEM_FETCHING,
    MARKET_GROUP_MARKET_TYPE_LIST_RECEIVED,
    MARKET_GROUP_MARKET_TYPE_LIST_FETCHING,
    MARKET_GROUP_TEMPLATE_DRAWER_CHANGED,
    MARKET_GROUP_RESULT_TYPE_DRAWER_CHANGED,
    MARKET_GROUP_MARKET_TYPE_DRAWER_CHANGED,
    MARKET_GROUP_TRANSLATIONS_MODAL_CHANGED,
    MARKET_GROUP_MONITORING_SELECTED_GROUP_CHANGED,
    MARKET_GROUP_NAME_FILTER_CHANGED,
    MARKET_GROUP_MULTIPLE_SELECT_TRANSLATIONS_MODAL_CHANGED,
    MARKET_GROUP_SELECT_TRANSLATIONS_MODAL_CHANGED,
    MARKET_LABEL_STATIC_DRAWER_CHANGED,
    MARKET_LABEL_STATIC_LIST_RECEIVED,
    MARKET_LABEL_STATIC_LIST_FETCHING,
    MARKET_LABEL_STATIC_ITEM_RECEIVED,
    MARKET_LABEL_STATIC_ITEM_FETCHING,
    MARKET_GROUP_INPUT_TRANSLATIONS_MODAL_CHANGED,
} from '../types';
import { MARKET_GROUPS_ALL_ID } from '../../utils/constants';

const initialState = {
    list: [],
    listFetching: false,
    current: null,
    currentFetching: false,
    currentType: '',
    outcomes: [],
    markets: [],
    template: {
        list: [],
        listFetching: false,
        current: null,
        currentFetching: false,
        drawerSettings: {
            isVisible: false,
        },
    },
    marketLabels: {
        list: [],
        listFetching: false,
        current: null,
        currentFetching: false,
        drawerSettings: {
            isVisible: false,
        },
    },
    resultType: {
        list: [],
        listFetching: false,
        current: null,
        currentFetching: false,
        drawerSettings: {
            isVisible: false,
        },
    },
    marketType: {
        list: [],
        listFetching: false,
        drawerSettings: {
            isVisible: false,
        },
    },
    translationsModal: {
        form: null,
        visible: false,
    },
    multipleSelectTranslationsModal: {
        form: null,
        visible: false,
        formItemName: '',
        name: '',
    },
    selectTranslationsModal: {
        form: null,
        visible: false,
        formItemName: '',
    },
    inputTranslationsModal: {
        form: null,
        formItemName: '',
        visible: false,
    },
    monitoringSelectedGroupId: MARKET_GROUPS_ALL_ID,
    filters: {
        keyword: '',
    },
};

const marketGroup = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case MARKET_GROUP_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case MARKET_GROUP_LIST_FETCHING: {
            return {
                ...state,
                listFetching: payload,
            };
        }
        case MARKET_GROUP_ITEM_RECEIVED: {
            return {
                ...state,
                current: payload.item,
                currentType: payload.type,
            };
        }
        case MARKET_GROUP_ITEM_FETCHING: {
            return {
                ...state,
                currentFetching: payload,
            };
        }
        case MARKET_GROUP_TEMPLATE_LIST_RECEIVED: {
            return {
                ...state,
                template: {
                    ...state.template,
                    list: payload,
                },
            };
        }
        case MARKET_GROUP_TEMPLATE_LIST_FETCHING: {
            return {
                ...state,
                template: {
                    ...state.template,
                    listFetching: payload,
                },
            };
        }
        case MARKET_GROUP_TEMPLATE_ITEM_RECEIVED: {
            return {
                ...state,
                template: {
                    ...state.template,
                    current: payload,
                },
            };
        }
        case MARKET_GROUP_TEMPLATE_ITEM_FETCHING: {
            return {
                ...state,
                template: {
                    ...state.template,
                    currentFetching: payload,
                },
            };
        }
        case MARKET_GROUP_TEMPLATE_DRAWER_CHANGED: {
            return {
                ...state,
                template: {
                    ...state.template,
                    drawerSettings: payload,
                },
            };
        }
        case MARKET_GROUP_RESULT_TYPE_LIST_RECEIVED: {
            return {
                ...state,
                resultType: {
                    ...state.resultType,
                    list: payload,
                },
            };
        }
        case MARKET_GROUP_RESULT_TYPE_LIST_FETCHING: {
            return {
                ...state,
                resultType: {
                    ...state.resultType,
                    listFetching: payload,
                },
            };
        }
        case MARKET_GROUP_RESULT_TYPE_ITEM_RECEIVED: {
            return {
                ...state,
                resultType: {
                    ...state.resultType,
                    current: payload,
                },
            };
        }
        case MARKET_GROUP_RESULT_TYPE_ITEM_FETCHING: {
            return {
                ...state,
                resultType: {
                    ...state.resultType,
                    currentFetching: payload,
                },
            };
        }
        case MARKET_GROUP_RESULT_TYPE_DRAWER_CHANGED: {
            return {
                ...state,
                resultType: {
                    ...state.resultType,
                    drawerSettings: payload,
                },
            };
        }
        case MARKET_GROUP_MARKET_TYPE_LIST_RECEIVED: {
            return {
                ...state,
                marketType: {
                    ...state.marketType,
                    list: payload,
                },
            };
        }
        case MARKET_GROUP_MARKET_TYPE_LIST_FETCHING: {
            return {
                ...state,
                marketType: {
                    ...state.marketType,
                    listFetching: payload,
                },
            };
        }
        case MARKET_GROUP_MARKET_TYPE_DRAWER_CHANGED: {
            return {
                ...state,
                marketType: {
                    ...state.marketType,
                    drawerSettings: payload,
                },
            };
        }
        case MARKET_GROUP_MARKETS_RECEIVED: {
            return {
                ...state,
                markets: payload,
            };
        }
        case MARKET_GROUP_COLUMN_TYPES_RECEIVED: {
            return {
                ...state,
                columnTypes: payload,
            };
        }
        case MARKET_GROUP_OUTCOMES_RECEIVED: {
            return {
                ...state,
                outcomes: payload,
            };
        }
        case MARKET_GROUP_TRANSLATIONS_MODAL_CHANGED: {
            return {
                ...state,
                translationsModal: payload,
            };
        }
        case MARKET_GROUP_MULTIPLE_SELECT_TRANSLATIONS_MODAL_CHANGED: {
            return {
                ...state,
                multipleSelectTranslationsModal: { ...state.multipleSelectTranslationsModal, ...payload },
            };
        }
        case MARKET_GROUP_SELECT_TRANSLATIONS_MODAL_CHANGED: {
            return {
                ...state,
                selectTranslationsModal: { ...state.selectTranslationsModal, ...payload },
            };
        }
        case MARKET_GROUP_INPUT_TRANSLATIONS_MODAL_CHANGED: {
            return {
                ...state,
                inputTranslationsModal: { ...state.inputTranslationsModal, ...payload },
            };
        }
        case MARKET_GROUP_MONITORING_SELECTED_GROUP_CHANGED: {
            return {
                ...state,
                monitoringSelectedGroupId: payload,
            };
        }
        case MARKET_GROUP_NAME_FILTER_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        }
        case MARKET_LABEL_STATIC_DRAWER_CHANGED: {
            return {
                ...state,
                marketLabels: {
                    ...state.marketLabels,
                    drawerSettings: payload,
                },
            };
        }
        case MARKET_LABEL_STATIC_LIST_RECEIVED: {
            return {
                ...state,
                marketLabels: {
                    ...state.marketLabels,
                    list: payload,
                },
            };
        }
        case MARKET_LABEL_STATIC_LIST_FETCHING: {
            return {
                ...state,
                marketLabels: {
                    ...state.marketLabels,
                    listFetching: payload,
                },
            };
        }
        case MARKET_LABEL_STATIC_ITEM_RECEIVED: {
            return {
                ...state,
                marketLabels: {
                    ...state.marketLabels,
                    current: payload,
                },
            };
        }
        case MARKET_LABEL_STATIC_ITEM_FETCHING: {
            return {
                ...state,
                marketLabels: {
                    ...state.marketLabels,
                    currentFetching: payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default marketGroup;
